/**
 * Cores sugeridas.
 *
 * A primeira é a da marca (`nohra.wine` do `tailwind.config.ts`) — é a cor que
 * todo documento tem hoje, então ela precisa ser a mais fácil de escolher de
 * volta depois de experimentar.
 */
export const CORES_SUGERIDAS: readonly { hex: string; nome: string }[] = [
  { hex: '#691241', nome: 'Vinho NOHRA' },
  { hex: '#0f766e', nome: 'Verde-água' },
  { hex: '#1d4ed8', nome: 'Azul' },
  { hex: '#15803d', nome: 'Verde' },
  { hex: '#334155', nome: 'Grafite' },
  { hex: '#7f1d1d', nome: 'Bordô' },
  { hex: '#6d28d9', nome: 'Roxo' },
  { hex: '#b45309', nome: 'Âmbar' },
];

/** O mesmo regex do DTO no backend. */
export const HEX = /^#[0-9a-fA-F]{6}$/;

/** O layout implícito de quem nunca configurou nada. */
export const COR_PADRAO = '#691241';

/**
 * Preto ou branco, o que for mais legível sobre `hexFundo`. Fórmula YIQ —
 * barata e boa o suficiente pra decidir só entre duas opções (não é um
 * contraste WCAG completo). Usado nas tags estilo Trello (cor do grupo vira
 * fundo do chip, então o texto precisa se adaptar).
 */
export function corDeTextoLegivel(hexFundo: string): string {
  const m = hexFundo.replace('#', '');
  const r = parseInt(m.substring(0, 2), 16);
  const g = parseInt(m.substring(2, 4), 16);
  const b = parseInt(m.substring(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? '#1a1a1a' : '#ffffff';
}
